import { Client } from "@/shared/model/client.model";
import { ReportDashboard } from "@/shared/model/global/dashboard/report-dashboard.model";
import axios from "axios";

const baseApiUrl = "api/report-dashboard";

export default class ReportDashboardService {
  public getReportDashboard(id: number): Promise<any> {
    return new Promise<ReportDashboard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public deleteReportDashboardById(id: number): Promise<any> {
    return new Promise<Client>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
